import type { JobDuration, JobState, JobWorkPlace } from '~/shared/data-contract/job';
import type { LearningOpportunityState, LearningOpportunityType } from '~/shared/data-contract/learning-opportunities';
import type { JobSeekingStatus, RelocationPreference } from '~/shared/data-contract/user';
import type { TranslationKey, TranslationResource } from '~/shared/internationalization/translation';

export const relocationPreferenceMap: Record<RelocationPreference, TranslationKey> = {
    'not open': 'common.enums.relocation-preference.not open',
    open: 'common.enums.relocation-preference.open',
    'relocation only': 'common.enums.relocation-preference.relocation only',
};

export const jobSeekingStatusMap: Record<JobSeekingStatus, TranslationKey> = {
    'not open': 'common.enums.job-seeking-status.not open',
    open: 'common.enums.job-seeking-status.open',
};

export const jobStateMap: Record<JobState, TranslationKey> = {
    archived: 'common.enums.job-state.archived',
    draft: 'common.enums.job-state.draft',
    hired: 'common.enums.job-state.hired',
    published: 'common.enums.job-state.published',
};

export const jobDurationMap: Record<JobDuration, TranslationKey> = {
    'fixed-term': 'common.enums.duration.fixed-term',
    permanent: 'common.enums.duration.permanent',
};

export const jobWorkPlaceMap: Record<JobWorkPlace, TranslationKey> = {
    'on-site': 'common.enums.work-place.on-site',
    remote: 'common.enums.work-place.remote',
};

export const learningOpportunityStateMap: Record<LearningOpportunityState, TranslationKey> = {
    all: 'pages.learning-opportunities.states.all',
    archived: 'pages.learning-opportunities.states.archived',
    draft: 'pages.learning-opportunities.states.draft',
    published: 'pages.learning-opportunities.states.published',
};

export const typesMap: Record<LearningOpportunityType, TranslationKey> = {
    course: 'pages.learning-opportunities.types.course',
};

export const languagesMap: Record<keyof TranslationResource['common']['languages'], TranslationKey> = {
    'cs-CZ': 'common.languages.cs-CZ',
    'de-DE': 'common.languages.de-DE',
    'en-US': 'common.languages.en-US',
    'es-ES': 'common.languages.es-ES',
    'es-MX': 'common.languages.es-MX',
    'fi-FI': 'common.languages.fi-FI',
    'fr-CA': 'common.languages.fr-CA',
    'fr-FR': 'common.languages.fr-FR',
    'hu-HU': 'common.languages.hu-HU',
    'ja-JP': 'common.languages.ja-JP',
    'ko-KR': 'common.languages.ko-KR',
    'ms-MY': 'common.languages.ms-MY',
    'nl-NL': 'common.languages.nl-NL',
    'pl-PL': 'common.languages.pl-PL',
    'pt-BR': 'common.languages.pt-BR',
    'pt-PT': 'common.languages.pt-PT',
    'ro-RO': 'common.languages.ro-RO',
    'it-IT': 'common.languages.it-IT',
    'sv-SE': 'common.languages.sv-SE',
    'zh-CN': 'common.languages.zh-CN',
    'zh-TW': 'common.languages.zh-TW',
};

export const stateMap: Record<string, TranslationKey> = {
    active: 'states.active',
    all: 'states.all',
    archived: 'states.archived',
    draft: 'states.draft',
    published: 'states.published',
};
